module ProcessEditor {
    interface IFormDisablerScope extends ng.IScope {
        process: Process;
    }

    export function frendsDisableFormsForOutdatedProcess(processService: ProcessService): ng.IDirective {
        return {
            restrict: "A",
            transclude: true,
            template: "<fieldset ng-disabled='process.isNotLatestVersion' ng-class='{isNotLatestVersion:process.isNotLatestVersion}' ng-transclude></fieldset>",
            link: (scope: IFormDisablerScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller, transclude: ng.ITranscludeFunction) => {
                scope.process = processService.currentProcess;
            }
        };
    }
    app.directive("frendsDisableFormsForOutdatedProcess", ["ProcessService", frendsDisableFormsForOutdatedProcess]);
}